import { makeStyles } from '@material-ui/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import { MDSSortBy, MDSTheme } from '@marqvision/mds/core';
import { MDSTypography } from '@marqvision/mds-v2';

const useStyles = makeStyles({
  wrapper: {
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  totalCount: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    '& strong': {
      ...MDSTheme.typography.medium,
    },
  },
});

type Props = {
  isLoading: boolean;
  totalCount?: number;
};

export const ActionSection = (props: Props) => {
  const { isLoading, totalCount } = props;
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.totalCount}>
        <MDSTypography variant="T14" weight="medium">
          {isLoading ? <Skeleton width="16px" /> : totalCount?.toLocaleString()}
        </MDSTypography>
        <MDSTypography variant="T14">
          Requests
        </MDSTypography>
      </div>
      <MDSSortBy label="Requested date (Newest)" isArrowIcon={false} />
    </div>
  );
};